/* global $pwb -- $pwb is the Pay with Bank global object provided by the external PWB library
   loaded via useScript */
import React, { useEffect } from 'react';
import { Button } from '@americanexpress/dls-react';
import { addLogToReport } from '@americanexpress/one-app-ducks';
import useScript from '../utils/useScript';
import { getLocaleByCountryCode, getRealtimeTimestamp, generateSecureRandomAlphaNumeric } from '../utils/commonUtils';
import { ACTION_VRP, BUTTON_TYPE_CUSTOM, NEXT_VIEW_VRP_UPDATE } from '../constants/appConstants';
import { SHOW_PWBT } from '../copyText/permissionsPage';
import { getClientContext } from '../utils/deviceUtils';

export default function ShowPWBT({ amexPaywithbank, action, dispatch }) {
  useScript('https://icm.aexp-static.com/Internet/IMDC/paywithbank/v3/js/pwb.js');

  useEffect(() => {
    window.amex_paywithbank_init = amexPaywithbank;
  });

  const commonPayload = {
    merchant_id: amexPaywithbank.merchant_id,
    country_code: amexPaywithbank.country_code,
  };

  // todo ls - pass vrp_details and consent_id for edit flow
  const FLOW_CONFIG = {
    create: {
      buttonText: SHOW_PWBT.CREATE_BTN,
      initPayload: {
        ...commonPayload,
        payment_details: amexPaywithbank.account_reference,
      },
    },
    edit: {
      buttonText: SHOW_PWBT.EDIT_BTN,
      initPayload: {
        ...commonPayload,
        next_view: NEXT_VIEW_VRP_UPDATE,
        vrp_details: '',
        vrp_consent_id: '',
      },
    },
  };

  const getFlowConfig = (flowType) => FLOW_CONFIG[flowType] || FLOW_CONFIG.create;

  function getUpdateInitValues(setupDetails) {
    // todo ls - get request id from backend
    const amexPaywithbankInit = {
      locale: getLocaleByCountryCode(setupDetails.country_code),
      timestamp: getRealtimeTimestamp(),
      request_id: generateSecureRandomAlphaNumeric(),
      button_type: BUTTON_TYPE_CUSTOM,
      action: ACTION_VRP,
    };

    return Object.assign(amexPaywithbankInit, setupDetails);
  }

  const getInitPayloadWithDelay = (flowType) => new Promise((resolve) => {
    setTimeout(() => {
      resolve(getFlowConfig(flowType).initPayload);
    }, 500);
  });

  const handleCreatePermission = () => {
    dispatch(addLogToReport('info', 'get pisp payload details', {
      moduleID: 'axp-bank-permissions-dashboard-root',
      message: 'Inside handleCreatePermission $pwb.openWindow(); is called',
      userAction: action,
      ...getClientContext(),
    }));
    $pwb.openWindow();
    getInitPayloadWithDelay(action).then((details) => {
      const pwbtInit = getUpdateInitValues(details);
      dispatch(addLogToReport('info', 'get pisp payload details', {
        moduleID: 'axp-bank-permissions-dashboard-root',
        message: 'Inside getInitPayloadWithDelay $pwb.updateInit(pwbtInit); is called',
        initPayload: pwbtInit,
        userAction: action,
        activeConsent: amexPaywithbank?.vrp_consent_details?.ACTIVE || null,
        deleteInProgressConsent: amexPaywithbank?.vrp_consent_details?.DELETE_PENDING || null,
        ...getClientContext(),
      }));
      $pwb.updateInit(pwbtInit);
    });
  };

  return (
    <Button variant="primary" onClick={() => handleCreatePermission()}>
      {getFlowConfig(action).buttonText}
    </Button>
  );
}
